const env = import.meta.env;

// Fallback to MODE if VITE_ENV is not set
const environment = env.VITE_ENV || env.MODE || "production";

const API_URLS = {
	development: "https://app.staging.ztron.ai",
	staging: "https://app.staging.ztron.ai",
	preview: "https://app.preview.ztron.ai",
	production: "https://app.ztron.ai",
} as const;

const CDN_URLS = {
	development: "https://cdn-dev.ztron.ai",
	staging: "https://cdn-staging.ztron.ai",
	preview: "https://cdn-dev.ztron.ai",
	production: "https://cdn.ztron.ai",
} as const;

export const config = {
	api: {
		base_url:
			API_URLS[environment as keyof typeof API_URLS] || API_URLS.production,
		prefix: "/api/v1",
	},
	cdn: {
		base_url:
			CDN_URLS[environment as keyof typeof CDN_URLS] || CDN_URLS.production,
	},
};
